import { Button, Card, CardBody, Container, Row, Col } from 'reactstrap';

type HolidayDeleteConfirmProps = {
  id: string;
  handleDelete: (id: string) => void;
  onClose: () => void;
};

const HolidayDeleteConfirm = ({ id, handleDelete, onClose }: HolidayDeleteConfirmProps) => {
  return (
    <Container fluid>
      <Card>
        <CardBody>
          <Row className="mt-3">
            <Col md="12">
              <span className="h2 font-weight-bold mb-0">Are you sure you want delete this holiday?</span>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md="6 text-center">
              <Button
                color="primary"
                href="#"
                onClick={() => {
                  handleDelete(id);
                  onClose();
                }}
                size="lg"
                style={{ minWidth: '100px' }}
              >
                Yes
              </Button>
            </Col>
            <Col md="6 text-center">
              <Button color="danger" href="#" onClick={onClose} size="lg" style={{ minWidth: '100px' }}>
                No
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Container>
  );
};

export default HolidayDeleteConfirm;
